module.exports = __webpack_public_path__ + "img/test-bg.e23bfb0c.png";